import Status from './src/main'

Status.install = function (Vue) {
  Vue.component(Status.name, Status)
}

export default Status
